module.exports = __webpack_public_path__ + "img/addToGooglePay_cs.dd5853eb.svg";